
import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogIndex from "../pages/blog/page";
import CloudAccountingSoftwarePage from '../pages/blog/top-cloud-accounting-softwares/page';
import BookkeepingMistakesPage from '../pages/blog/bookkeeping-mistakes-el-paso/page';
import CompareTaxPreparationServicesPage from '../pages/blog/011_situations-we-help-with-by-buying-your-property-cash/page';
import MonthlyBookkeepingPage from '../pages/blog/why-el-paso-small-businesses-need-monthly-bookkeeping/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogIndex />,
  },
  {
    path: "/blog/top-cloud-accounting-softwares",
    element: <CloudAccountingSoftwarePage />,
  },
  {
    path: "/blog/bookkeeping-mistakes-el-paso",
    element: <BookkeepingMistakesPage />,
  },
  {
    path: "/compare-el-paso-tax-preparation-services",
    element: <CompareTaxPreparationServicesPage />,
  },
  {
    path: "/blog/why-el-paso-small-businesses-need-monthly-bookkeeping",
    element: <MonthlyBookkeepingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
